module.exports = __webpack_public_path__ + "static/shawna-friend-stretching-4dab096e7329fd78368f659ae42288b8.jpg";